module.exports = __webpack_public_path__ + "static/media/clientChirag.d8c85c88.png";